const NAMES = [
  'Kestrel', 'Vigil', 'Aurora', 'Harrier', 'Solace', 'Tempest', 'Lodestar', 'Wraith',
  'Corsair', 'Halcyon', 'Ember', 'Nomad', 'Sable', 'Meridian', 'Talon', 'Zephyr',
  'Paladin', 'Cinder', 'Onyx', 'Vesper', 'Rook', 'Seraph', 'Drifter', 'Lantern',
];

const NUMERALS = ['', ' II', ' III', ' IV', ' V', ' VI', ' VII', ' VIII', ' IX', ' X'];

/** Name for the `n`th ship commissioned (from 1). Names repeat with a numeral once the list runs out. */
export function shipName(n: number): string {
  const index = Math.max(0, n - 1);
  const generation = Math.floor(index / NAMES.length);
  const numeral = NUMERALS[generation] ?? ` ${generation + 1}`;
  return NAMES[index % NAMES.length] + numeral;
}
